Core.PortalCheckoutHomeModification = (function() {
    var NS = 'checkoutHomeModification';
    var fileUploadObj = {};
    var map = null;
    var pop = null;
    var cls_hide = 'invisible-height';

    function executeCallback(clb) {
        clb();
    };

    function countFiles() {
        return document.querySelectorAll('#checkoutHomeModification .fileUpload-fileList input[type=hidden]').length;
    }

    function OptionsError() {
        return {
            show() {
                if ($( "#checkoutHomeModification-fileupload .error-options" ).length) {
                    return;
                }

                $('#checkoutHomeModification-fileupload.fileUpload').append('<label class="error error-options">Please add instructions or attachments if you require home modification</label>');
            },

            clear() {
                $('#checkoutHomeModification-fileupload .error-options').remove();
            }
        }
    }

    var v = {};

    /*


        DATA


     */

    var d = {
        state: '',
        installer: '',
        instructions: '',
        fileCounter: 0,
        subscriberList: {
            selectedState: [],
            selectedInstaller: [],
            textInstructions: [],
            files: [],
        },

        set selectedState(state) {
            this.state = state;
            this.selectedInstaller = '';

            d.subscriberList.selectedState.forEach(executeCallback);
        },

        get selectedState() {
            return this.state;
        },

        set selectedInstaller(installer) {
            this.installer = installer;

            d.subscriberList.selectedInstaller.forEach(executeCallback);
        },

        get selectedInstaller() {
            return this.installer;
        },

        set textInstructions(instructions) {
            this.instructions = instructions;

            d.subscriberList.textInstructions.forEach(executeCallback);
        },

        get textInstructions() {
            return this.instructions;
        },

        set files(count) {
            this.fileCounter = count;

            d.subscriberList.files.forEach(executeCallback);
        },

        get files() {
            return this.fileCounter;
        },

        subscribe(name, callback) {
            d.subscriberList[name].push(callback);
        }
    };


    /*


        METHODS


     */

    var m = {
        init: function() {
            m.onPageLoad();
            m.handleHomeModRadio();

            m.loadVar();
            m.loadCallback();

            m.updateState();
            m.onStateChange();

            m.updateInstallerSelect();

            m.updateDetails();

            m.onTextInstructionsChange();
            m.onFilesChange();
            m.initMap();
            m.goTo();

            m.listenBtnClick();
            m.initModal();
            m.setValidators();

            m.onBtnClick();
            m.handleItemsToBeInstalled();
            m.handleAuthorisationRadio();

            setTimeout(function () {
                m.initFilesUpload();
                m.initDrawingTool();
                m.initSignaturePad();
                m.initDatePicker2();
            }, 300);
        },

        onPageLoad: function() {
            // skip validation on hidden fields
            $('#frmHomeModification').validate({
                ignore: ":hidden, .invisible-height input"
            });

            // re-init style
            $("input[type=checkbox], input[type=radio]").uniform();

            var changeEvt = new Event('change');
            setTimeout(() => {
                // home mod required options
                var selectedHomeMod = document.querySelector('#homeModRequiredOptions .toggle-radiogroup-content[name="homeModRequired"]:checked');
                selectedHomeMod && selectedHomeMod.dispatchEvent(changeEvt);

                // authorization options
                var selectedOption = document.querySelector('#authorisationOptionList .toggle-radiogroup-content[name="authorisationOption"]:checked');
                selectedOption && selectedOption.dispatchEvent(changeEvt);
            }, 0);
        },

        handleHomeModRadio: function() {
            Core.PortalCheckoutToggleRadioContent.handleRadioClick($('#homeModRequiredOptions .portal-radio__listbox-options-item'));
            $('#homeModRequiredOptions .toggle-radiogroup-content[name="homeModRequired"]').on('change', function(e) {
                var $el = $(this);
                Core.PortalCheckoutToggleRadioContent.resetRadio($el);                

                if (`${$el.val()}` === 'true') $('#divHomeModification').removeClass(cls_hide);
                else $('#divHomeModification').addClass(cls_hide);
            });
        },

        handleAuthorisationRadio: function() {
            const authOptions = {
                Own: ["#section-your-auth"],
                Rent: ["#section-landlord-auth", "#section-landlord-upload", "#section-your-auth"],
                Other: ["#section-approval-letter", "#section-your-auth"],
            };

            Core.PortalCheckoutToggleRadioContent.handleRadioClick($('#authorisationOptionList .portal-radio__listbox-options-item'));
            $('#authorisationOptionList .toggle-radiogroup-content[name="authorisationOption"]').on('change', function(e) {
                var $el = $(this);
                var selectedOption = $el.val();
                Core.PortalCheckoutToggleRadioContent.resetRadio($el);
                $('.portal-checkout__section-auth').addClass(cls_hide); // hide all section first
                authOptions[selectedOption].forEach((item) => $(item).removeClass(cls_hide));
            });
        },

        initFilesUpload: function() {
            var uploaderList = Array.from(document.querySelectorAll('#checkoutHomeModification .fileUpload'));

            uploaderList.forEach(function(elem) {
                fileUploadObj[elem.id] = new Core.FileUpload(elem);
                fileUploadObj[elem.id].init();
            });
        },

        loadVar: function() {
            d.selectedState = $(".selectedState").val();
            d.selectedInstaller = $(".selectedInstaller").val();
            d.textInstructions = $("#homeModificationInstructions").val();
            d.files = countFiles();
        },

        loadCallback: function() {
            d.subscribe('selectedState', m.updateInstallerSelect);
            d.subscribe('selectedState', m.isValidState);

            d.subscribe('selectedInstaller', m.updateDetails);
            d.subscribe('selectedInstaller', m.goTo);

            d.subscribe('textInstructions', m.isValidOptions);
            d.subscribe('files', m.isValidOptions);
        },

        setValidators: function() {
            v['state'] = new SelectValidator("#dropdownInstallerState");
            v['installer'] = new SelectValidator("#dropdownInstallerInState");
            v['options'] = {
                isValid: function() {
                    var error = new OptionsError();
                    var hasOption = (m.hasTextInstructions() || m.hasFiles());

                    hasOption
                        ? error.clear()
                        : error.show();

                    return hasOption;
                }
            }
        },

        isValidState: function() {
            setTimeout(v['state'].isValid, 100);
        },

        isValidInstaller: function() {
            setTimeout(v['installer'].isValid, 100);
        },

        isValidOptions: function() {
            setTimeout(v['options'].isValid, 100);
        },



        /*


            STATE


         */

        updateState: function() {
            var selectedState = d.selectedState;

            if (selectedState === '' || selectedState === 'all') {
                return;
            }

            $('#dropdownInstallerState').data("kendoDropDownList").value(selectedState);
        },

        onStateChange: function() {
            function updateDataState() {
                d.selectedState = $("#dropdownInstallerState").data("kendoDropDownList").value();
                $(".selectedState").val(d.selectedState);
                $(".selectedInstaller").val(d.selectedInstaller);
            };

            $("#dropdownInstallerState").data("kendoDropDownList").bind("change", updateDataState);
        },



        /*


            INSTALLERS


         */

        getInstallersList: function() {
            var selectedState = d.selectedState;

            function isInstallerInState(installer) {
                return installer.State
                    ? installer.State.toLowerCase() === selectedState.toLowerCase()
                    : false;
            }

            if (selectedState === '' || selectedState === 'all') {
                return [{Name: "Pick an installer", "Id": ""}];
            }


            if (typeof window.InstallersJson === 'undefined' || typeof window.InstallersJson.Installers === 'undefined') {
                return [{Name: "Pick an installer", "Id": ""}];
            }


            var installerListInState = window.InstallersJson.Installers.filter(isInstallerInState);
            return [{Name: "Pick an installer", "Id": ""}].concat(installerListInState);
        },

        getInstaller: function() {
            function isSelectedInstaller(installer) {
                return installer.Id === d.selectedInstaller;
            };

            return m.getInstallersList().find(isSelectedInstaller);
        },

        updateInstallerSelect: function() {
            var selectedInstaller = d.selectedInstaller;
            var installerList = m.getInstallersList();

            $("#dropdownInstallerInState").kendoDropDownList({
                dataSource: installerList,
                dataTextField: "Name",
                dataValueField: "Id"
            });

            $("#dropdownInstallerInState").data("kendoDropDownList").value(selectedInstaller);
            m.onInstallerChange();
        },

        onInstallerChange: function() {
            function updateDataInstaller() {
                d.selectedInstaller = $("#dropdownInstallerInState").data("kendoDropDownList").value();
                $(".selectedInstaller").val(d.selectedInstaller);
                m.isValidInstaller();
            };

            $("#dropdownInstallerInState").data("kendoDropDownList").bind("change", updateDataInstaller);
        },



        /*


            INSTRUCTIONS


         */

        onTextInstructionsChange: function() {
            function updateDataTextInstructions() {
                d.textInstructions = $("#homeModificationInstructions").val();
                m.isValidOptions();
            };

            $("#homeModificationInstructions").on("keyup", updateDataTextInstructions);
        },



        /*


            FILES


         */

        onFilesChange: function() {
            function updateDataFiles(e) {
                d.files = countFiles();
                m.isValidOptions();

                // loop for fileupload element, if it has uploadded file, remove error message
                var $fileUploads = $('.fileUpload');
                $fileUploads.each(function(i, item) {
                    var $item = $(item);
                    var $error = $item.find('.error');
                    var $fileList = $item.find('.fileUpload-fileList');
                    var hasFile = $fileList.find('.fileUpload-file').length > 0;
                    if (hasFile) {
                        $error.html('');
                    }
                });
            };

            document.addEventListener(`${NS}.fileUploaded`, updateDataFiles);
            document.addEventListener(`${NS}.fileDeleted`, updateDataFiles);
        },


        hasMinimumRequirements: function() {
            var hasOption = (m.hasTextInstructions() || m.hasFiles());

            return m.hasValidInstaller() && hasOption;
        },

        hasValidSignature: function() {
            var signatures = {
                client1: 'Signature-Client1',
                client2: 'Signature-Client2',
                landlord: 'Signature-Landlord',
            };

            var checkSignature = function($signature, signatureObj) {
                const $error = $signature.find('.error');
                if (signatureObj && !signatureObj.isEmpty()) {
                    // check date, if exist then show error validation to save
                    const $clientDate = $signature.find("input.signaturePad-dateInput");
                    const $saveButton = $signature.find("button[data-action=save-png]");
                    const $fileUpload = $signature.find('.fileUpload');
                    const $fileList = $fileUpload.find('.fileUpload-fileList .fileUpload-file');
                    const hasBeenSaved = $fileList.length > 0;
                    // check fileupload list
                    if (!hasBeenSaved) {
                        $error.html('Please save your signature first');
                        $saveButton.addClass('pulse');
                        return false;
                    } else if (!$clientDate.val()){
                        // show date error message
                        $error.html('Please select date');
                        return false;
                    } else {
                        $error.html('Please provide client signature');
                        return false;
                    }
                } else {
                    $error.html('Please provide client signature');
                    Core.ScrollToView($signature.offset().top - 50);
                    return false;
                }
            }

            var checkSignatureDate = function($signature) {
                const clientDateVal = $signature.find("input.signaturePad-dateInput").val();
                const $error = $signature.find('.error');
                if (!clientDateVal) {
                    $error.html('Please select date');
                    return false;
                } else {
                    // check if date is valid
                    const dateObj = moment(clientDateVal, "DD/MM/YYYY", true);
                    if (!dateObj.isValid()) {
                        $error.html('Invalid date');
                        return false;
                    } else {
                        return true;
                    }
                }
            }

            var hasClient1 = $('#checkoutHomeModification-clientSignature1Upload .fileUpload-fileList .fileUpload-file').length > 0;
            var $client1Wrapper = $('#checkoutHomeModification-clientSignature1Upload').closest('.signaturePad-wrapper');
            var $client1Error = $client1Wrapper.find('.error');
            $client1Error.html('');
            if (!hasClient1) {
                // check if signature exist, but it's not being saved
                var client1Obj = signaturePadList[signatures.client1];
                return checkSignature($client1Wrapper, client1Obj);
            } else {
                var isDateValid = checkSignatureDate($client1Wrapper);
                if (!isDateValid) return false;
            }

            var hasClient2 = $('#checkoutHomeModification-clientSignature2Upload .fileUpload-fileList .fileUpload-file').length > 0;
            var $client2Wrapper = $('#checkoutHomeModification-clientSignature2Upload').closest('.signaturePad-wrapper');
            var $client2Error = $client1Wrapper.find('.error');
            $client2Error.html('');
            if (!hasClient2) {
                // check if signature exist, but it's not being saved
                var client2Obj = signaturePadList[signatures.client2];
                var $client2Date = $client2Wrapper.find("input.signaturePad-dateInput");
                if ((client2Obj && !client2Obj.isEmpty()) || $client2Date.val()) {
                    return checkSignature($client2Wrapper, client2Obj);
                }
            } else {
                var isDateValid = checkSignatureDate($client2Wrapper);
                if (!isDateValid) return false;
            }

            var selectedAuthorisation = $('#authorisationOptionList input[type="radio"]:checked').val();
            switch (selectedAuthorisation) {
                case "Rent":
                    var hasSignature = $('#checkoutHomeModification-landlordSignatureUpload .fileUpload-fileList .fileUpload-file').length > 0;
                    var hasUploadLetter = $('#checkoutHomeModification-landlordLetter .fileUpload-fileList .fileUpload-file').length > 0;
                    var isFormValid = $('#frmHomeModification #section-landlord-auth fieldset input').valid();
                    
                    var $landlordWrapper = $('#checkoutHomeModification-landlordSignatureUpload').closest('.signaturePad-wrapper');
                    var $landlordError = $landlordWrapper.find('.error');
                    $landlordError.html('');

                    var landlordObj = signaturePadList[signatures.landlord];
                    if (!hasSignature && landlordObj && !landlordObj.isEmpty()) {
                        return checkSignature($landlordWrapper, landlordObj);
                    }

                    if (!hasSignature && !hasUploadLetter) {
                        $landlordError.html('Please provide landlord signature and/or upload approval letter');
                        Core.ScrollToView($landlordWrapper.offset().top - 10);
                    }
                    return hasClient1 && isFormValid && (hasSignature || hasUploadLetter);

                case "Other":
                    var hasUploadLetter = $('#checkoutHomeModification-approvalLetter .fileUpload-fileList .fileUpload-file').length > 0;
                    var $errorUploadLetter = $('#checkoutHomeModification-approvalLetter.fileUpload .error-options');
                    if (!hasUploadLetter) {
                        if ($errorUploadLetter.length === 0) {
                            $('#checkoutHomeModification-approvalLetter.fileUpload').append('<label class="error error-options">Approval letter is required</label>');
                        } else {
                            $errorUploadLetter.html('Approval letter is required');                            
                        }
                    } else {
                        $errorUploadLetter.remove();
                    }
                    return hasClient1 && hasUploadLetter;

                case "Own":                    
                default:
                    return hasClient1;
            }
        },

        hasValidInstaller: function() {
            return (d.selectedInstaller !== '' && d.selectedState !== '');
        },

        hasTextInstructions: function() {
            return (d.textInstructions.length > 0);
        },

        hasFiles: function() {
            return (d.files > 0);
        },



        /*


            BUTTONS


         */

        checkBtn: function() {
           $("#btnContinueHomeMod").attr('disabled', ! m.hasMinimumRequirements());
        },

        onBtnClick: function() {
            var isSubmitted = false;
            var setIsSubmittedFalse = function() {
                isSubmitted = false;
            }

            var scrollToFirstError = function() {
                var $errorList = $('#frmHomeModification .error');
                // loop error list and find the first visible error element that has content
                $errorList.each(function(i, item) {
                    var $item = $(item);
                    if ($item.is(':visible') && $item.text().length > 0) {
                        Core.ScrollToView($item.offset().top - 350);
                        return false;
                    }
                });
            };

            var onClick = function() {
                var isHomeModRequired = `${$('#homeModRequiredOptions input[name="homeModRequired"]:checked').val()}` === 'true';
                var $error = $('.checkoutHomeModification-error');
                var errorMessages = [];

                $error.html('');
                if (!isHomeModRequired) {
                    return;
                }
                
                m.isValidState();
                m.isValidInstaller();
                m.isValidOptions();

                if (! m.hasMinimumRequirements()) {
                    setTimeout(() => {
                        scrollToFirstError();
                    }, 300);
                    return;
                }

                // reorder file list names to send to server
                var $list = $('#checkoutHomeModification .fileUpload .fileUpload-fileList');
                var hasSignatureUpload = m.hasValidSignature();
                $list.find('.fileUpload-file').each(function(i, item) {
                    var $file = $(item);
                    var $parent = $file.closest('.fileUpload');
                    var dataFile = $parent.data('upload-class');
                    var dataFileName = $parent.data('original-file-name-class');
                    
                    var $signatureWrapper = $parent.closest('.signaturePad-wrapper');
                    var $uploadedOriginalFileNames = $file.find('.UploadedOriginalFileNames');
                    var nameIndex = i;

                    // if it's a signature upload, rename the file using the latest date
                    if ($signatureWrapper.length > 0) {
                        nameIndex = 0; // always reset to 0 for signature
                        var fileName = $signatureWrapper.data('file-name');
                        var dateVal = $signatureWrapper.find('input.signaturePad-dateInput').val();
                        var dateObj = moment(dateVal, "DD/MM/YYYY");                        

                        if (dateVal && dateObj.isValid()) {
                            $uploadedOriginalFileNames.val(`${fileName}_${dateObj.format("DDMMYYYY")}.png`);
                        }
                    }

                    $file.find('.UploadedFiles').prop('name', `${dataFile}[${nameIndex}]`);
                    $uploadedOriginalFileNames.prop('name', `${dataFileName}[${nameIndex}]`);
                });

                if (!hasSignatureUpload) {
                    errorMessages.push('Please provide required signature and/or upload files');
                }

                if (errorMessages.length > 0) {                    
                    // $error.html(errorMessages.join('<br>'));
                    setTimeout(() => {
                        scrollToFirstError();
                    }, 300);
                    return;
                }

                m.resetAuthFields();

                !isSubmitted && hasSignatureUpload &&
                    ( isSubmitted = true
                    , setTimeout(setIsSubmittedFalse, 500)
                    , $('#frmHomeModification').trigger('submit')
                    );
            };

            var btn = document.querySelector("#btnContinueHomeMod");
            btn && btn.addEventListener('click', onClick);
        },



        /*


            DETAILS


         */

        updateDetails: function() {
            var $desc = $('.home-mod-option-desc');
            var $details = $('.home-mod-details');
            var installer = m.getInstaller();

            if (!installer || !installer.AddressLine1) {
                $content = '&nbsp;';
                $desc.show();
                $details.html($content);
                $details.hide();
                return;
            }

            $content = '<h4>' + installer.Name + '</h4>'
                        + '<p>' + installer.AddressLine1 + '</p>'
                        + '<p>' + installer.Suburb + '</p>'
                        + '<p>' + installer.State + ', ' + installer.Postcode + '</p>'
                        + '<p>Phone: ' + installer.Phone + '</p>'
                        + (installer.BusinessHours ? '<p class="mt-3">Business Hours: </p> <div class="mt--3">' + installer.BusinessHours + '</div>' : '');

            $desc.hide();
            $details.html($content);
            $details.show();
        },



        /*


            MAP


         */

        initMap: function() {
            var $mapCanvas = $("#google-map-canvas-home-mod");

            if ($mapCanvas.length) {
                var data = (typeof window.InstallersJson === 'undefined' || typeof window.InstallersJson.Installers === 'undefined')
                    ? []
                    : window.InstallersJson.Installers;

                map = Core.Map($mapCanvas[0]);
                map.init();
                map.plotMarkers(data);
            }
        },

        goTo: function() {
            var installer = m.getInstaller();

            (!installer || !installer.AddressLine1)
                ? map.setState(d.selectedState)
                : map.goTo(installer.Latitude, installer.Longitude);
        },


        /*


            HOME MOD BUTTONS
            - listenBtnClick init both btns listners


         */

        listenBtnClick: function() {
            m.onClickBtnContinueHomeMod();
            m.onClickBtnNoHomeModRequired();
        },

        onClickBtnContinueHomeMod: function() {
            $("#btnContinueHomeMod").on('click', function(e) {
                e.preventDefault();

                // check home mod radio options value
                var isHomeModRequired = `${$('#homeModRequiredOptions input[name="homeModRequired"]:checked').val()}` === 'true';

                if (isHomeModRequired) {
                    $('.homeMods').val('true');
                    $("#btnContinueHomeMod").unbind('click').trigger('click');
                    setTimeout(m.onClickBtnContinueHomeMod, 250);   
                } else {
                    $("#btnNoHomeModRequired").trigger('click');
                }
            });
        },

        onClickBtnNoHomeModRequired: function() {
            $("#btnNoHomeModRequired").on('click', function(e) {                
                e.preventDefault();

                if (m.isModalNoHomeMod()) {
                    m.showModal();
                    return;
                }

                $('.homeMods').val('false');
                m.doClickNoHomeModRequired();
            });
        },

        // unbind click and bind event
        // required to submit the no home mode form
        doClickNoHomeModRequired: function() {
            m.resetForm();               
            $("#btnNoHomeModRequired").unbind('click').trigger('click');
            setTimeout(m.onClickBtnNoHomeModRequired, 250);
        },

        /*

            on ajax_homemods_OnComplete
            we fire `aidacare.home-mod-completed`
            portalCheckout will listen and refresh the cart items
            Core.PortalCheckoutHomeModification.homeModCompletedEvent()

         */
        homeModCompletedEvent: function() {
            var event = new Event('aidacare.home-mod-completed');
            document.dispatchEvent(event);

            // remove error message
            setTimeout(() => {
                var error = new OptionsError();
                error.clear();
                
                // remove files and notes if no home mod required clicked
                if ($('.homeMods').val().toLowerCase() === 'false') {
                    $('#checkoutHomeModification .fileUpload-fileList').empty();
                    $("#homeModificationInstructions").val('');
                    $('.drawingTool-canvas').drawr('clear');
                }
            }, 1000);
        },


        /*


            NO HOME MOD MODAL
            - if only product in the cart is home mod
            - if user click yes (which means remove)
              then we do remove and refresh the page


         */

        isModalNoHomeMod: function() {
            return $('#btnNoHomeModRequired').data("confirm") || m.hasMinimumRequirements();
        },

        showModal: function() {
            pop.data("kendoWindow").center().open();
        },

        initModal: function() {
            pop = $('#confirm')
                        .kendoWindow({
                            title: "CONFIRM NO HOME MOD",
                            visible: false,
                            iframe: false,
                            modal: true,
                            resizable: false,
                            pinned: true,
                            draggable: false,
                            animation: false,
                        });

            $('[data-name="no"]').on('click', function() {
                pop.data("kendoWindow").close();
            });

            $('[data-name="yes"]').on('click', function() {
                pop.data("kendoWindow").close();
                $('.homeMods').val('false');

                m.doClickNoHomeModRequired();
            });
        },

        initDrawingTool: function() {
            var fileUploadId = "checkoutHomeModification-fileupload";
            var $fileUploadEl = $(`#${fileUploadId}`);

            if ($("#homeMod-draw").length > 0) {
                var drawingTool = new Core.DrawingTool("#homeMod-draw");
                drawingTool.init(fileUploadObj[fileUploadId], $fileUploadEl);                
            }
        },

        handleItemsToBeInstalled: function() {
            var removeItem = function($item) {
                $item.remove();
            };

            $('.itemsToBeInstalled-btnAdd').on('click', function() {
                var index = $('.itemsToBeInstalled-item').length;
                var template = `
                    <div class="itemsToBeInstalled-item">
                        <input type="text" placeholder="Item name" class="itemsToBeInstalled-input" name="ItemsToBeInstalled[${index}]">
                    </div>
                `;
                $('.itemsToBeInstalled-list').append(template);               
            });

            $('.itemsToBeInstalled-btnRemove').on('click', function() {
                removeItem($(this).closest('.itemsToBeInstalled-item'));
            });
        },

        initSignaturePad: function() {
            var fileUploadId = "checkoutHomeModification-fileupload";
            var $fileUploadEl = $(`#${fileUploadId}`);
            var signaturePadObj = new Core.SignaturePad(fileUploadObj, $fileUploadEl);
            
            signaturePadObj.init();
        },

        initDatePicker2: function() {
            var rootDom = document.querySelector('#checkoutHomeModification');
    
            Array
                .from(rootDom.querySelectorAll('.signaturePad-dateInput'))
                .forEach(function(item) {
                    Core.DatePicker2(item).init();

                    var datepicker = $(item).data("kendoDatePicker");
                    datepicker.setOptions({
                        max: new Date()
                    });
                });
        },

        resetForm: function() {
            $('#checkoutHomeModification .fileUpload-fileList').empty();
            $('#checkoutHomeModification').find('textarea, input[type="text"], select').val('');
            $('#checkoutHomeModification').find('input[type="checkbox"]').prop('checked', false);
            $.uniform.update();
        },

        // reset field for unselected options
        resetAuthFields: function() {
            // send only fields within selected authorisation option
            var $textFields = $(`#frmHomeModification .portal-checkout__section-auth input[type="text"], #frmHomeModification .portal-checkout__section-auth input[type="tel"]`);
            var $uploadFields = $(`#frmHomeModification .portal-checkout__section-auth .fileUpload`);
            var landlordObj = signaturePadList['Signature-Landlord'];
            if (landlordObj) landlordObj.clear();

            // get the fields that are not visible, then reset the value
            $textFields.map(function(i, item) {
                var $item = $(item);
                var isVisible = $item.closest('.invisible-height').length === 0;
                if (!isVisible) {
                    $item.val('');
                }
            });

            $uploadFields.map(function(i, item) {
                var $item = $(item);
                var isVisible = $item.closest('.invisible-height').length === 0;
                if (!isVisible) {
                    // trigger delete unused files
                    var $files = $item.find('.fileUpload-fileList .fileUpload-file');
                    $files.each(function(i, file) {
                        var $file = $(file);
                        var $deleteBtn = $file.find('.fileUpload-delete');
                        $deleteBtn.trigger('click');
                    });
                    // reset file upload
                    $item.find('input').val('');
                    $item.find('.fileUpload-fileList').empty();
                }
            });
        },
    };

    return m;
})();
